// extracted by mini-css-extract-plugin
export default {"container":"uj-z","blurb":"vj-z","links":"wj-z"};